import Axios from "axios";
import React, { Component } from "react";
import { Bar } from 'react-chartjs-2';  
import AppConfig from "../../../../../config/AppConfig";
class ChartSebaranPelaporanBerdasarkanJenis extends Component {
    constructor(props) {
      super(props)
      this.state = {
        label :[],
        belum_mengisi: [],
        belum_lengkap: [],
        sudah_lengkap: [],
        loading: false,
      }
    }
    
    options = {
        indexAxis: 'y',
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    userCallback: function(label, index, labels) {
                        // when the floored value is the same as the value we have a whole number
                        if (Math.floor(label) === label) {
                            return label;
                        }
   
                    },
                }
            }],
        },
        plugins: {
            legend: {
                display: true,
                position: 'bottom'
            }
        }
    }

    getData(){
        this.setState({
            loading: true,
        });
        let id_institusi = localStorage.getItem("id_sp_temp");
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let id_sp = sessiondata.i_idunit;
        if(id_institusi !== ""){
            id_sp = id_institusi;
        }if(id_institusi === null){
            id_sp = sessiondata.i_idunit;
        }
        let session = "";
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        if(userdata){
            session = 
            "?tipe_lembaga="+this.props.tipe_lembaga+
            "&id_pengguna="+userdata.id_pengguna+
            "&id_unit="+ id_sp +
            "&id_role="+sessiondata.i_idrole;
        }
        let i = 0;
        let labels = [];
        let belum_mengisi = [];
        let belum_lengkap = [];
        let sudah_lengkap = [];
          Axios.get(
            AppConfig.DetailDashboard+"sebaranpelaporanbyjenis"+session
          ).then(res => {
            for (var key in res.data.result.data_vokasi) {
                labels[i] = key;
                belum_mengisi[i] = res.data.result.data_vokasi[key].belum_mengisi;
                belum_lengkap[i] = res.data.result.data_vokasi[key].belum_lengkap;
                sudah_lengkap[i] = res.data.result.data_vokasi[key].sudah_lengkap;
                i = i + 1;
            }
            
            this.setState({
                label: labels,
                belum_mengisi: belum_mengisi,
                belum_lengkap: belum_lengkap,
                sudah_lengkap: sudah_lengkap,
                loading: false,
            });
          }) 
          .catch(err => {
            alert("not found")
          }) 
    }
    async componentDidMount(){
        this.getData();
    }

    async componentDidUpdate(){
        if(this.props.status === true){
            this.getData();
            this.props.parentCallback(false);
        }
    }

    render(){
      let datas = {
        labels: this.state.label,
        datasets: [
            {
                label: 'Belum Mengisi',
                fill: false,
                lineTension: 0.1,
                backgroundColor: '#4472C4',
                borderColor: '#4472C4',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: '#4472C4',
                pointBackgroundColor: '#4472C4',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: '#4472C4',
                pointHoverBorderColor: '#4472C4',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: this.state.belum_mengisi
            },
            {
                label: 'Belum Lengkap',
                fill: false,
                lineTension: 0.1,
                backgroundColor: '#ED7D39',
                borderColor: '#ED7D39',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: '#ED7D39',
                pointBackgroundColor: '#ED7D39',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: '#ED7D39',
                pointHoverBorderColor: '#ED7D39',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: this.state.belum_lengkap
            },
            {
                label: 'Sudah Lengkap',
                fill: false,
                lineTension: 0.1,
                backgroundColor: '#F8C145',
                borderColor: '#F8C145',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: '#F8C145',
                pointBackgroundColor: '#F8C145',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: '#F8C145',
                pointHoverBorderColor: '#F8C145',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: this.state.sudah_lengkap
            },
        ]
      };
        return(
            <>
                {this.state.loading === true ? <span className="ml-3 spinner spinner-black"></span> : <Bar data={datas} options={this.options}/>}
            </>
        )
    }
}
export default ChartSebaranPelaporanBerdasarkanJenis;